import { createAction, props } from '@ngrx/store';

import { LeaderBoardDetails, LeaderBoardRequest } from '../models/leaderboard-details';

export const leaderboardInit = createAction('[LeaderBoard Promotion] Init');
export const leaderboardDestroyed = createAction('[LeaderBoard Promotion] Destroyed');
export const loadLeaderBoardData = createAction('[LeaderBoard Promotion] LoadData', props<LeaderBoardRequest>());

export const leaderBoardOptinSuccess = createAction('[LeaderBoard Promotion] Optin Success', props<LeaderBoardDetails>());
